import { RootState } from 'store';
import { initialFilters } from './config';

export const selectCusat = (state: RootState) => state.cusat;

export const selectCusatItems = (state: RootState) => state.cusat.items;

export const selectCusatFilters = (state: RootState) => state.cusat.filters;

export const selectCusatSort = (state: RootState) => state.cusat.sort;

export const selectCusatPagination = (state: RootState) =>
  state.cusat.pagination;

export const selectCusatLoading = (state: RootState) => state.cusat.loading;

export const selectCusatUpdating = (state: RootState) => state.cusat.updating;

export const selectCusatExporting = (state: RootState) => state.cusat.exporting;

export const selectCusatImporting = (state: RootState) => state.cusat.importing;

export const selectIsAnyCusatFilterSet = (state: RootState) =>
  (Object.keys(initialFilters) as Array<keyof typeof initialFilters>).some(
    (key) => state.cusat.filters[key] !== initialFilters[key],
  );
